module.exports = __webpack_public_path__ + "static/media/onboarding_company.f8462ca0.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/onboarding_company.png
// module id = 1101
// module chunks = 0